import { createContext } from "react";
import { TMainContext } from "./user-information-provider";

export const MainContext = createContext<TMainContext>({
	setUserData: () => {},
	userData: {
		ssn: "",
		phone_number: "",
	},
	removeUserData: () => {},
});
